<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Postal Ballot</strong>
      </span>
      <span style="float: right">
        <!-- <a routerLink="/postalballot/add"> -->
          <button (click)="add()" class="btn btn-success pull-right" [appHasPermission]="{'Url': '/register/postallballotlist/edit?goveva=true&email=', 'method':'put', 'menu': 'postallballotlist'}" class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
    </div>
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
            class="fa fa-filter" aria-hidden="true"></i></span> </div>
      <div class="card-block collapse" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-md-3">
                <label>Name of Shareholder</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="nameOfShareholder" name="nameOfShareholder" class="form-control">
                </div>
                <br>
              </div>
              <div class="col-md-3">
                <!-- <label>Date of Receipt of postal ballot form</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From:&nbsp;
                  <input id="dateofReceipt" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateofReceipt" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateofReceipt">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div>
  
              <div class="col-md-3">
                
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  To:&nbsp;
                  <input id="dateofReceiptTo" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateofReceiptTo" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateofReceiptTo">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
              <div class="col-lg-2 col-lg-2 col-sm-2 ">
                <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                <br>
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
          </div>
        </div>
  
      </div>
    </section>
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfRegisterDirector" [dtTrigger]="dtTriggerRegisterDirector"
                class="table table-hover compact cell-border nowrap stripe" id="masterpostalballotlistTable"
                style="cursor: pointer;">
                <thead>
                  <tr>
                    <!-- <th>Sr. No. given by the scrutinizer</th>  <td tabindex="1"> {{director.srNoGivenByTheScrutinizer}} </td>-->
                    <th>Folio No. of the<br> Shareholder</th>
                    <th>Date of receipt of <br>postal ballot form</th>
                    <th style="display: none">Date of receipt of postal ballot form</th>
                    <th>Name of the Shareholder</th>
                    <th>Client ID number <br> of the Shareholder</th>
                    <!-- <th>No. of votes in favour</th>
                    <th>No. of votes in against</th>
                    <th>No. of invalid votes and reasons thereof</th> <td tabindex="1"> {{director.votesInFavour}} </td>
                    <td tabindex="1"> {{director.votesAgainst}} </td>
                    <td tabindex="1"> {{director.invalidVotes}} </td>-->
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let director of registerDirectorList;let i=index">
                   <td tabindex="1"> {{director.folioNo}} </td>
                   
                    <td tabindex="1">
                      <span style="display: none">{{director.dateOfReceiptpb | date : "yMMdd"}}</span>
                      {{director.dateOfReceiptpb | date:'dd-MM-y'}}
                    </td>
                    <td tabindex="1" style="display: none">
                      {{director.dateOfReceiptpb | date:'dd-MM-y'}}
                    </td>
                    <td tabindex="1"> {{director.nameOfShareholder}} </td>
                   
                    <td tabindex="1"> {{director.clientIdNumberSH}} </td>
                  
                    <td style='white-space: nowrap'>
                      <div class="input-group">
                        <button type="button" (click)="editpostalballot(director._id)" class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/postallballotlist/edit?goveva=true&email=', 'method':'put', 'menu': 'postallballotlist'}">
                          <span class="fa fa-pencil"></span>
                        </button>
                        &nbsp;&nbsp;
                        <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)" [appHasPermission]="{'Url': '/register/postallballotlist/edit?goveva=true&email=', 'method':'put', 'menu': 'postallballotlist'}">
                          <span class="icmn-bin"></span>
                        </button>
                      </div>
                    </td>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete postal ballot details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deletepostalballotdetail()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-alert></app-alert>